import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
  useReactFlow,
  getStraightPath,
} from "@xyflow/react";
import { Button, Popover } from "antd";
import { EdgePopUp } from "./nodes";

export function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}: EdgeProps) {
  const { setEdges } = useReactFlow();
  //   const [edgePath, labelX, labelY] = getBezierPath({
  //     sourceX,
  //     sourceY,
  //     sourcePosition,
  //     targetX,
  //     targetY,
  //     targetPosition,
  //   });

  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const onEdgeClick = () => {
    // setEdges((edges) => edges.filter((edge) => edge.id !== id));
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
          }}
          className="nodrag nopan"
        >
          <Popover
            content={<EdgePopUp edgeId={id} />}
            trigger="click"
            overlayClassName="edge-popover"
          >
            <button className="diamond" onClick={onEdgeClick}></button>
          </Popover>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}

export const edgeTypes = {
  customEdge: CustomEdge,
};
